import { useSelector } from "react-redux";

import useSelectedPlanType from "../hooks/useSelectedPlanType";
import { PLAN_TYPES } from "../constants/personaldata";

const useActivePromotion = () => {
    const _planType = useSelectedPlanType();
    const _activePromotion = useSelector(state => state.HomeInsurance.activePromotion);
    return {
        activePromotion: _planType === PLAN_TYPES.CUSTOM ? _activePromotion : null,
    };
};

export default useActivePromotion;
